@for (motdMessage of headerMotdMessages; track motdMessage.id; let i = $index) {
  <nz-alert
    nzType="info"
    [nzMessage]="motdMessage.title"
    [nzDescription]="motdMessage.body"
    nzCloseable
    nzShowIcon
    [nzAction]="motdMessage.isDismissible ? actionTemplate : null"
  ></nz-alert>
  <ng-template #actionTemplate>
    <button nz-button nzSize="small" nzType="primary" nzGhost (click)="dismissMotdMessage(motdMessage, i)">Vairs nerādīt</button>
  </ng-template>
}
